define('views/modules/calendar/activity/detail/blocks/advanced-details',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    'services/i18n',
    // events
    'services/events/calendar-events',
    // views
    'views/parts/info-section',
    'views/parts/form/sliderbar',
    'views/parts/form/select',
    'views/parts/form/textbox',
    // models & collections
    'models/calendar/text-session/activity-type',
    // templates
    'text!templates/modules/calendar/activity/detail/blocks/advanced-details.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    //  services
    User,
    i18n,
    // events
    CalendarEvents,
    // views
    VInfoSection,
    VSliderbar,
    VSelect,
    VTextbox,
    // models & collections
    MActivityType,
    // templates
    TAdvancedDetails
) {

    var VAdvancedDetails = Backbone.View.extend({
        template: TAdvancedDetails,

        // abstracting selectors out of the view logic
        regions: {
            difficulty: ".difficulty",
            activityList: '.activity-list',
            time: '.time-input',
        },

        events: {
            'focus .time-input': 'onTimeInputFocus',
            'focusout .time-input': 'onTimeInputFocusOut',
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                profile: opt.profile,
                masterCarbon: opt.masterCarbon
            });

            this.profile = this.options.profile;

            var model = this.model,
                view = this.view = {
                    info: new VInfoSection({
                        title: "calendar:What is your activity?",
                        //help: "messages:helpbox-activity-detail",
                        content: this.template,
                    }),
                    sliders: {
                        difficulty: new VSliderbar({
                            labels: ["calendar:Very easy", "calendar:Normal", "calendar:Very hard"],
                            color: true,
                            label: 'calendar:At what intensity?',
                            model: model,
                            className: 'slider-effort',
                            attribute: 'effort',
                        })
                    },
                    activityList: new VSelect({
                        label: 'Activity',
                        labelposition: "top",
                        option: { label: 'name', value: MActivityType.prototype.idAttribute, namespace: 'activities' },
                        attribute: 'activity',
                        model: model,
                        collection: this.collection
                    }),
                    time: new VTextbox({
                        model: model,
                        attribute: 'durationMinutes',
                        labelposition: 'top',
                        label: 'For how long?',
                        addon: true,
                        addonBefore: '<span class="sl-icon-clock"></span>',
                        addonAfter: "Minutes"
                    }),
                };

            this.initModelListeners();

            this.listenTo(CalendarEvents, 'onActivitySaveClick', this.disableModelListeners);

            this.listenTo(this.collection, { 'sync': this.onCollectionSync });
        },

        disableModelListeners: function() {
            this.stopListeningTo(this.model);
        },

        initModelListeners: function() {
            this.listenTo(this.model, {
                "change:activity": this.onActivityChange,
                "change:effort": this.onEffortChange,
                "change:duration": this.onDurationChange,
            });
        },

        render: function() {
            var view = this.view;
            this.assign(view.info, this.$el); // must be first

            this.initModelListeners();

            // Caching scoped jquery element from 'regions'.
            this.generateZones();
            var zone = this.zone;

            // Assign Views
            this.assign(view.sliders.difficulty, zone.$difficulty, { defer: true })
                .assign(view.activityList, zone.$activityList)
                .assign(view.time, zone.$time);

            if (this.model.get('activity') == null) {
                this.setDefaultActivity();
            }
            // applying model silently to avoid calories being calculated X number of times
            this.model.trigger('apply:model', {silent: true});

            // To have raw calories, not calculated
            this.model.setCalories(this.masterCarbon.getCalories());

            return this;
        },

        setDefaultActivity: function() {
            var lastActivityId = User.getLastActivityId(),
                activityList = this.view.activityList;
            if (lastActivityId) {
                activityList.setValue(lastActivityId);
            } else {
                activityList.selectFirstOption();
            }

            this.activity = this.getActivity(activityList.getValue());
        },

        getActivity: function(value) {
            var activityId = value || this.model.get('activity');
            return this.collection.get(activityId);
        },

        calculateCalories: function() {
            if (this.activity) {
                var calculatedCalories = this.model.getCalculatedCalories(this.activity, this.profile);
                this.model.set('calories', calculatedCalories);
            }
        },

        getTranslatedCollection: function(collection, ns) {
            var newCollection = new Backbone.Collection();

            newCollection.add(
                _.map(collection.models, function(model) {
                    return model.set('name', i18n.t(model.get('name'), { ns: ns }));
                })
            );

            return newCollection;
        },

        /////////////
        // events //
        /////////////

        onActivityChange: function(model, value) {
            this.activity = this.getActivity(value);
            this.calculateCalories();
        },

        onEffortChange: function(model, value) {
            this.calculateCalories();
        },

        onDurationChange: function(model, value) {
            this.calculateCalories();
        },

        onCollectionSync: function(collection) {
            this.collection.reset(this.getTranslatedCollection(collection, 'activities').models);
            this.collection.sort();

            this.activity = this.getActivity();
            if (!this.activity) {
                this.setDefaultActivity();
            }

            this.render();
        },

        onTimeInputFocus: function(e) {
            var model = this.model,
                input = this.view.time,
                duration = model.get('duration');
            if (duration === 0) {
                input.setInputValue("");
            }
        },

        onTimeInputFocusOut: function(e) {
            var model = this.model,
                input = this.view.time,
                duration = model.get('duration');
            if (!duration) {
                input.setInputValue(0);
            }
        },

    });

    return VAdvancedDetails;

});

